module.exports = "HrDashboard";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/hr/hr.dashboard.html
// module id = 447
// module chunks = 0